const HouseBuildDataset = [
   "housePart1.png", "housePart2.png", "housePart3.png", "housePart4.png",
   "housePart5.png", "houseComplete.png"
]

export default HouseBuildDataset;